export const COLORS = {
  primary: '#4F46E5',
  primaryLight: '#818CF8',
  primaryDark: '#3730A3',
  primaryGhost: '#EEF2FF',
  success: '#059669',
  successLight: '#D1FAE5',
  warning: '#D97706',
  warningLight: '#FEF3C7',
  danger: '#DC2626',
  dangerLight: '#FEE2E2',
  info: '#0284C7',
  infoLight: '#E0F2FE',
  g50: '#F9FAFB',
  g100: '#F3F4F6',
  g200: '#E5E7EB',
  g300: '#D1D5DB',
  g400: '#9CA3AF',
  g500: '#6B7280',
  g600: '#4B5563',
  g700: '#374151',
  g800: '#1F2937',
  g900: '#111827',
};

export const STATUS_MAP = {
  active: { bg: COLORS.successLight, color: COLORS.success },
  published: { bg: COLORS.successLight, color: COLORS.success },
  valid: { bg: COLORS.successLight, color: COLORS.success },
  pass: { bg: COLORS.successLight, color: COLORS.success },
  paid: { bg: COLORS.successLight, color: COLORS.success },
  exempt: { bg: COLORS.infoLight, color: COLORS.info },
  inactive: { bg: COLORS.g200, color: COLORS.g600 },
  draft: { bg: COLORS.g200, color: COLORS.g600 },
  pending: { bg: COLORS.warningLight, color: COLORS.warning },
  review: { bg: COLORS.infoLight, color: COLORS.info },
  paused: { bg: COLORS.warningLight, color: COLORS.warning },
  scheduled: { bg: COLORS.infoLight, color: COLORS.info },
  expired: { bg: COLORS.dangerLight, color: COLORS.danger },
  in_service: { bg: COLORS.warningLight, color: COLORS.warning },
  unpaid: { bg: COLORS.dangerLight, color: COLORS.danger },
  high: { bg: COLORS.dangerLight, color: COLORS.danger },
  medium: { bg: COLORS.warningLight, color: COLORS.warning },
  low: { bg: COLORS.infoLight, color: COLORS.info },
  suspended: { bg: COLORS.dangerLight, color: COLORS.danger },
};

export const ROLES = ['admin', 'manager', 'editor', 'user'];
export const USER_TYPES = ['Student', 'Teacher', 'School', 'Other', 'Admin User'];
export const USER_STATUSES = ['active', 'inactive', 'pending', 'suspended'];
export const NEWS_CATEGORIES = ['policy', 'regulation', 'technology', 'report', 'environment'];
export const NEWS_STATUSES = ['draft', 'review', 'published'];
export const AD_TYPES = ['banner', 'image', 'video', 'native', 'popup', 'carousel', 'interstitial'];
export const AD_PLACEMENTS = [
  { value: 'after_every_5_ads', label: 'After every 5 ads' },
  { value: 'before_footer', label: 'Before the footer' },
  { value: 'between_news', label: 'Between news items' },
  { value: 'side_popup', label: 'Side popup' },
  { value: 'top_of_page', label: 'At the top of the page' },
];
// Matches Ad.MAX_LINKS in backend/models/Ad.js — an ad carries up to this many
// destination URLs, of which exactly one is active.
export const MAX_AD_LINKS = 5;
export const AD_CATEGORIES = ['promotional', 'seasonal', 'awareness', 'discount', 'subscription', 'event', 'product_launch', 'referral', 're_engagement', 'brand'];
export const PRIORITIES = ['low', 'medium', 'high'];
export const VEHICLE_TYPES = ['suv', 'sedan', 'hatchback', 'electric', 'off_road', 'truck'];
export const FUEL_TYPES = ['petrol', 'diesel', 'electric', 'hybrid', 'cng'];
export const VEHICLE_STATUSES = ['active', 'in_service', 'inactive'];

export const formatLabel = (str) => {
  if (!str) return '';
  return str.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};
